import axios from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh";

/*Axios Configuration */
const axiosConfig = {
  // eslint-disable-next-line no-undef
  baseURL: config.axiosBaseUrl,
};

/*Axios Instance */
const axiosInstance = axios.create(axiosConfig);

// Function that will be called to refresh authorization
const refreshAuthLogic = (failedRequest) =>
  axios
    .get(axiosConfig.baseURL + "auth", {
      headers: {
        Authorization: "Login YXBp",
      },
    })
    .then((res) => {
      window.config.token = res.data;
      failedRequest.response.config.headers["Authorization"] =
        "Token " + res.data;
      /*Axios Temp Bug Fix to convert headers to plain object https://github.com/axios/axios/issues/5143 */
      failedRequest.response.config.headers = {
        ...failedRequest.response.config.headers,
      };
      return Promise.resolve();
    })
    .catch((error) => {
      console.log(error);
    });

// Instantiate the interceptor
createAuthRefreshInterceptor(axiosInstance, refreshAuthLogic);

export default axiosInstance;
